import React, { Suspense } from 'react';
import { useTypedSelector } from '@hooks';
import { useAuth } from '@hooks/useAuth';
import { useDebounced } from '@helpers/useDebounced';

const MoveModal = React.lazy(() => import('./MoveModal'));

export default function MoveModalContainer() {
  const { user } = useAuth();
  const modalState = useTypedSelector(({ modal }) => modal.moveModal);
  const visibleDebounced = useDebounced(modalState?.visible, 300, false);
  const visible = modalState?.visible || visibleDebounced;
  if (!modalState || !visible || !user) return null;

  return (
    <Suspense fallback={null}>
      <MoveModal {...modalState} />
    </Suspense>
  );
}
